// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky-footer[data-v-6f2bb38e]{display:flex;justify-content:center;align-items:center;height:70px;background-color:#fff;z-index:2;box-shadow:1px -5px 10px hsla(0,0%,39.2%,.2)}", ""]);
// Exports
module.exports = exports;
